import React, { memo, useState } from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import Rating from '@mui/material/Rating'
import IconButton from '@mui/material/IconButton'
import ClearIcon from '@mui/icons-material/Clear'
import sx from './styles'

const GoogleRatingCard = ({
  description, rating = 0, sx: sxProp, isToggled = false,
}) => {
  const [isVisible, setIsVisible] = useState(true)
  return (
    isVisible && (
      <Box
        sx={{ ...sx.root, ...sxProp }}
        className={clsx('Google-Rating-root')}
      >
        <Grid
          container
          alignItems="center"
        >
          <Grid size="grow">
            <Typography
              component="legend"
              variant="h2"
              sx={sx.ratingNumber}
            >
              {rating}
            </Typography>
            <Typography
              component="legend"
              variant="h2"
              sx={sx.ratingNumber}
            >
              <Rating
                value={rating}
                precision={0.5}
                readOnly
                sx={sx.rating}
              />
            </Typography>
          </Grid>
          <Grid
            size="grow"
            sx={sx.textDescription}
          >
            <Typography
              sx={sx.ratingText}
            >
              <FormattedMessage id={description} />
            </Typography>
          </Grid>
          {isToggled && (
            <Grid size="auto">
              <IconButton
                size="small"
                sx={sx.closeBtn}
                onClick={() => setIsVisible(false)}
              >
                <ClearIcon
                  fontSize="medium"
                  sx={sx.closeIcon}
                />
              </IconButton>
            </Grid>
          )}

        </Grid>
      </Box>
    )
  )
}

export default memo(GoogleRatingCard)
